module.exports = __webpack_public_path__ + "media/images/4-83846cb1c2420b7c57e2aa428f718bca.jpg";